export const INSURANCE_PROVIDERS = '/insuranceProviders'

export const getInsuranceProviderRoute = (
  insuranceProviderId: string
): string => `${INSURANCE_PROVIDERS}/${insuranceProviderId}`

export const referralInsuranceProvidersSearchRoute = (
  searchTerm: string
): string => `${INSURANCE_PROVIDERS}/search/${searchTerm}`
